module.exports = __webpack_public_path__ + "static/media/mysql.bd009c14.svg";